import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    CartLineModel,
    CartModel,
    OrderLineModel,
    ProductDto,
    ProductModel,
    QuoteLineModel,
    WishListLineModel,
} from "@insite/client-framework/Types/ApiModels";

interface GA4Event {
    event: string;
    ecommerce: GA4Ecommerce;
    search_term?: string;
    user_id?: string;
}

interface GA4Ecommerce {
    user_id?: string;

    // add more if needed
}

// OOTB from file /modules/client-framework/src/Common/Utilities/tracking.ts
// get global for google tag manager
function getDataLayer() {
    return (window as any).dataLayer;
}

function setData(eventData: any) {
    const dataLayer = getDataLayer();
    if (dataLayer) {
        dataLayer.push(eventData);
    } else {
        (window as any).dataLayer = [eventData];
    }
}

// cartlines is either a QuoteLineModel[], a CartLineModel[] or a ProductModel (or keep adding more types)
export const setGA4Event = (
    cartLines:
        | QuoteLineModel[]
        | CartLineModel[]
        | CartModel
        | ProductDto[]
        | ProductModel[]
        | OrderLineModel[]
        | WishListLineModel[]
        | Array<{ product: ProductModel; productInfo: Omit<ProductInfo, "productDetailPath"> }>
        | Array<{ product: CartLineModel; productInfo: Omit<ProductInfo, "productDetailPath"> }>
        | [],
    eventName: string,
    additionalInfo?: Partial<GA4Ecommerce>,
) => {
    if (IS_SERVER_SIDE) {
        return;
    }

    let eventData = {
        event: eventName,
        ecommerce: {},
    } as GA4Event;

    if (eventName === "login") {
        eventData = {
            event: eventName,
            user_id: additionalInfo?.user_id ?? "",
        } as GA4Event;
    }

    setData(eventData);
};
